module.exports = __webpack_public_path__ + "media/images/gallery/constellations/leo_minor/lmi_names-44ffe7a4d818e493e6b1401e0d6de46f.gif";